import React, { memo, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

import { checkIsPurchaseFlow } from 'utils/loanApplication';

import { selectCommonInfoLoanApplication } from 'store/loanApplications/selectors';

import { BORROWING_ENTITY_TABS_HREF } from '../../../../../EditEntityModal.constants';
import { pagesPropTypes } from '../../../MainContent.constants';

import { getConfig } from './PropertyAndLoan.config';
import { normalizeForm } from './PropertyAndLoan.utils';

const PropertyAndLoan = ({
  changedFields,
  isLoading,
  isSaving,
  form,
  validationErrors,
  validateField,
  handleChange,
  entityId,
  setEntityConfig,
  setForm,
  setInForm,
  pendingChanges,
  disabledPendingChangesHighlight,
  openedSectionsRef,
}) => {
  const { loanPurpose } = useSelector(selectCommonInfoLoanApplication);

  const isPurchaseFlow = checkIsPurchaseFlow(loanPurpose);
  const isBorrowerSectionWasOpened = openedSectionsRef.current[entityId]?.has(
    BORROWING_ENTITY_TABS_HREF.BORROWER,
  );

  const sectionForm = form[entityId]?.declarations?.propertyAndLoan ?? {};

  const { ownershipInterestPastThreeYears, partOfDownPaymentBorrowed } = sectionForm;

  const config = useMemo(
    () =>
      getConfig({
        entityId,
        ownershipInterestPastThreeYears,
        partOfDownPaymentBorrowed,
        isPurchaseFlow,
        isBorrowerSectionWasOpened,
      }),
    [
      entityId,
      ownershipInterestPastThreeYears,
      partOfDownPaymentBorrowed,
      isPurchaseFlow,
      isBorrowerSectionWasOpened,
    ],
  );

  useEffect(() => {
    setForm(form => normalizeForm({ form, entityId }));
  }, [config, entityId, setForm]);

  useEffect(() => {
    if (!config) {
      return;
    }

    setEntityConfig(config);
  }, [config, setEntityConfig]);

  return (
    <FormGenerator
      isNestedForm
      changedFields={changedFields}
      config={config}
      disabledPendingChangesHighlight={disabledPendingChangesHighlight}
      form={form}
      formName={FormNames.DECLARATIONS}
      handleChange={handleChange}
      isLoading={isSaving || isLoading}
      numberOfColumns={1}
      pendingChanges={pendingChanges}
      setInForm={setInForm}
      validateField={validateField}
      validationErrors={validationErrors}
    />
  );
};

PropertyAndLoan.propTypes = pagesPropTypes;

export default memo(PropertyAndLoan);
